import { Container, Typography } from "@mui/material"


export const SessionExpiredCard = () => {
    return (
        <Container maxWidth="sm">
            <Typography variant="h5" component="h2" gutterBottom>
                Sesión Expirada
            </Typography>
            <Typography variant="body1" color="textSecondary">
                Tu sesión finalizó seras redirigido al login...
            </Typography>
        </Container>
    )
}